import { Header } from 'widgets/header';
import { FC, ReactNode, useCallback, useEffect, useRef } from 'react';
import { useAppDispatch } from 'shared/lib/store';
import { ModalProvider } from 'shared/ui/modal';
import { getWaitingOrders } from 'entities/orders';
import { getDateRangeFromToday } from 'shared/lib/datepicker';
import { useLocation } from 'react-router-dom';
import { useResize } from 'app/lib/hooks/useResize';
import { HeaderMobile } from 'widgets/header/ui/headerMobile';

interface DashboardContainer {
	children: ReactNode;
	fetchTimeslotsOnInit?: boolean;
}

export const DashboardContainer: FC<DashboardContainer> = ({ children }) => {
	const dispatch = useAppDispatch();
	const { pathname } = useLocation();

	const isWaitingListCalled = useRef(false);

	const getOrdersByCurrentDate = useCallback(async () => {
		if (pathname !== '/waiting-list') {
			const [today, dayAfterTomorrow] = getDateRangeFromToday(true);
			dispatch(
				getWaitingOrders({
					dt_start__gte: today.toISOString(),
					dt_end__lte: dayAfterTomorrow.toISOString(),
					page: 1,
				}),
			);
		}
	}, [pathname, dispatch]);

	useEffect(() => {
		if (!isWaitingListCalled.current) {
			getOrdersByCurrentDate();
			isWaitingListCalled.current = true;
		}
	}, [getOrdersByCurrentDate]);

  const { 
    isScreenMd
  } = useResize();

	return (
		<ModalProvider>
      {isScreenMd ? <Header /> : <HeaderMobile />}
			{children}
		</ModalProvider>
	);
};
